import React, { useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import * as yup from 'yup';
import { SupportController } from '../../controllers';
import { EditFaqCategory } from '../../pages';

const EditFaqCategoryContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = () => {
        return (
            yup.object().shape({
                name: yup.string().required("Enter category name"),                
            })
        )
    }   

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            name: values.name,
            order: values.order,           
        }
        const { status, errorMessage } = await SupportController.editFaqCategory(            
            payload,
            data._id
            );

        if (status === constant.Success) {
            SupportController.getFaqs();           
            MimaToastUtil.success({ message: constant.Success })          
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <EditFaqCategory
        loading={loading}
        onSubmit={onSubmit}
        closeModal={closeModal}
        data={data}
        validationSchema={validationSchema}
        />
    )
}
export default EditFaqCategoryContainer;